import { createFileRoute } from '@tanstack/react-router'

import { DeliverabilityPage } from '#/modules/communication/deliverability-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/deliverability')({
  component: DeliverabilityPage,
  validateSearch: validateListSearch,
})
